import React from "react";
import CanvasFrameStandard from "./CanvasFrameStandard";
import CanvasFrameHorizontal from "./CanvasFrameHorizontal";
import CanvasFrameVertical from "./CanvasFrameVertical";

const EditCanvas = ({ 
  imageSrc, 
  imageMeta,
  canvasElRef, 
  CARD_WIDTH,
  CANVAS_HEIGHT,
  layoutStyle
}) => {
  
  const commonProps = {
    imageSrc,
    imageMeta,
    canvasElRef,
    CARD_WIDTH,
    CANVAS_HEIGHT,
  };

  // 這裡只負責顯示，不再包含下拉選單
  return (
    <div style={{ 
      flex: 1,
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      minHeight: 0,
    }}>
      
      {/* 渲染外框容器 */}
      <div style={{ 
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)", 
        borderRadius: 12, // 預覽框也是圓角
        overflow: "hidden" 
      }}>
        {layoutStyle === "standard" && <CanvasFrameStandard {...commonProps} />}
        {layoutStyle === "horizontal" && <CanvasFrameHorizontal {...commonProps} />}
        {layoutStyle === "vertical" && <CanvasFrameVertical {...commonProps} />}
      </div>

    </div>
  );
};

export default EditCanvas;